import * as THREE from "three";
import { JOINT_COLORS, JOINT_SPHERE_SIZES } from "../joints/jointStyles";
import { findJointVizGroupInScene, safeTraverse } from "./sceneObjectLookups";

export const JOINT_SELECTION_HIGHLIGHT_NAME = "__jointSelectionHighlight";

export function removeJointSelectionHighlights(root) {
  if (!root) return;
  const toRemove = [];
  safeTraverse(root, (obj) => {
    if (obj?.userData?.isJointSelectionHighlightSphere) {
      toRemove.push(obj);
    }
    if (obj?.userData?.isJointSelectionGlowOnly) {
      obj.visible = false;
    }
  });
  for (const obj of toRemove) {
    obj.parent?.remove(obj);
    obj.geometry?.dispose();
    obj.material?.dispose();
  }
}

export function getJointSelectionHighlightRadiusFromVizGroup(group) {
  const r = group?.userData?.selectionHighlightRadius;
  if (Number.isFinite(Number(r)) && Number(r) > 0) {
    return Number(r);
  }
  const proxy = group?.userData?.centerPickProxy;
  const pr = proxy?.geometry?.parameters?.radius;
  if (Number.isFinite(Number(pr)) && Number(pr) > 0) {
    return Number(pr);
  }
  return JOINT_SPHERE_SIZES.center;
}

export function addJointSelectionHighlight(scene, jointUuid) {
  if (!scene || !jointUuid) return;
  removeJointSelectionHighlights(scene);
  const group = findJointVizGroupInScene(scene, jointUuid);
  if (!group) return;

  if (group.userData?.jointType === "slide") {
    safeTraverse(group, (obj) => {
      if (obj?.userData?.isJointSelectionGlowOnly) {
        obj.visible = true;
      }
    });
    return;
  }

  const radius = getJointSelectionHighlightRadiusFromVizGroup(group);
  const mesh = new THREE.Mesh(
    new THREE.SphereGeometry(radius, 24, 18),
    new THREE.MeshBasicMaterial({
      color: JOINT_COLORS.glow,
      transparent: true,
      opacity: 0.24,
      depthTest: false,
      depthWrite: false,
    })
  );
  mesh.name = JOINT_SELECTION_HIGHLIGHT_NAME;
  mesh.position.set(0, 0, 0);
  mesh.renderOrder = 10002;
  mesh.userData.isJointSelectionHighlightSphere = true;
  mesh.raycast = () => {};
  group.add(mesh);
}
